import {Pipe, PipeTransform} from '@angular/core';
import {OuvragesUtils} from 'app/shared/utils/ouvrages.utils';

/**
 * Renvoie la class CSS pour une qualification.
 */
@Pipe({name: 'paramQualifClass'})
export class ParamQualifClassPipe implements PipeTransform {

    constructor() {
    }

    transform(qualif: string): string {
        return OuvragesUtils.getParametreQualifClass(qualif);
    }
}
